// import React, { useState } from 'react';
// import { useLocation } from 'react-router-dom'; // Import useLocation from react-router-dom
// import { FaDownload, FaSave } from 'react-icons/fa';
// import { IoMdArrowBack } from 'react-icons/io';
// import { BsCheckCircle } from 'react-icons/bs';
// import './AfterJD.css';
// import Navbar from '../About/Navbar';
// import Footer from '../About/Footer';
// import { useNavigate } from 'react-router-dom';

// const JobDescriptionPreview = () => {

//   const navigate = useNavigate();
//   const [showPopup, setShowPopup] = useState(false);
//   const location = useLocation();
//   const { jdData } = location.state || {};

//   // Optionally log to check the data
//   console.log(jdData);

//   const [currentPage, setCurrentPage] = useState(1);
//   const totalPages = 2; // Adjust based on your content

//   const nextPage = () => {
//     if (currentPage < totalPages) setCurrentPage(currentPage + 1);
//   };

//   const prevPage = () => {
//     if (currentPage > 1) setCurrentPage(currentPage - 1);
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await fetch('/api/create_jd', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(jdData)
//       });
//       setShowPopup(true);
//       setTimeout(() => {
//         navigate('/ch'); // Redirect to dashboard after saving
//       }, 3000);
//     } catch (error) {
//       console.error('Error generating JD:', error);
//     }
//   };

//   const SuccessPopup = () => (
//     <div className="success-popup-overlay">
//       <div className="success-popup">
//         <div className="success-icon">✓</div>
//         <h2>Successfully Created JD!</h2>
//       </div>
//     </div>
//   );

//   return (
//     <div className="page-container">
//       {showPopup && <SuccessPopup onClose={() => setShowPopup(false)} />}
//       <Navbar />

//       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "20px" }}>
//           <div className="job-preview-header">
//             <BsCheckCircle className="success-icon" />
//           </div>
//           <h2 className='jph'>Your document is ready</h2>
//         </div>

//         <div className="job-preview-actions">
//           <button className="edit-button" onClick={handleSubmit}>
//             <FaSave className="icon" />
//             <span>Save JD</span>
//           </button>
//           <button className="edit-button" onClick={() => navigate('/jd', { state: { jdData: jdData } })}>
//             <IoMdArrowBack className="icon" />
//             <span>Back to editing</span>
//           </button>
//         </div>

//         {/* Job Description Preview */}
//         <div className='afterjd'>
//           <h4>JD Title |</h4>
//           <div className="pagination-controls" style={{ display: "flex", justifyContent: "center" }}>
//             <button className='prev' onClick={prevPage} disabled={currentPage === 1}>{currentPage}</button>
//             <button className='nex' onClick={nextPage} disabled={currentPage === totalPages}>{totalPages}</button>
//           </div>
//           <div className="job-preview-box">
//             {currentPage === 1 && (
//               <>
//                 <h3>{jdData?.jobTitle || 'Job Title'}</h3>
//                 <div className="job-section">
//                   <strong>Job Summary:</strong>
//                   <p>{jdData?.jobSummary || jdData?.job_overview || 'No summary available'}</p>
//                 </div>
//                 <div className="job-section">
//                   <strong>Responsibilities & Skills:</strong>
//                   <ul>
//                     {jdData?.keyResponsibilities?.split(',').map((resp, index) => (
//                       <li key={index}>{resp}</li>
//                     ))
//                       ||
//                       jdData?.key_responsibilities?.split(',').map((resp, index) => (
//                         <li key={index}>{resp}</li>
//                       ))
//                     }
//                   </ul>
//                 </div>
//                 <div className="job-section">
//                   <strong>Required Skills:</strong>
//                   <ul>
//                     {jdData?.requiredSkills?.split(',').map((skill, index) => (
//                       <li key={index}>{skill}</li>
//                     ))
//                       ||
//                       jdData?.required_skills?.split(',').map((skill, index) => (
//                         <li key={index}>{skill}</li>
//                       ))}
//                   </ul>
//                 </div>
//                 <div className="job-section">
//                   <strong>Good-to-Have Skills (Optional):</strong>
//                   <ul>
//                     {jdData?.optionalSkills?.split(',').map((skill, index) => (
//                       <li key={index}>{skill}</li>
//                     ))
//                       ||
//                       jdData?.optional_skills?.split(',').map((skill, index) => (
//                         <li key={index}>{skill}</li>
//                       ))}
//                   </ul>
//                 </div>
//               </>
//             )}

//             {currentPage === 2 && (
//               <>
//                 <div className="job-section">
//                   <strong>Work & Culture Details (Optional):</strong>
//                   <p><strong>Soft Skills:</strong> {jdData?.softSkills || 'N/A'}</p>
//                   <p><strong>Work Hours:</strong> {jdData?.workHours || 'N/A'}</p>
//                   <p><strong>Company Culture:</strong> {jdData?.companyCulture || 'N/A'}</p>
//                 </div>
//                 <div className="job-section">
//                   <strong>Hiring Process:</strong>
//                   <p>{jdData?.hiringProcess || 'N/A'}</p>
//                 </div>
//                 <div className="job-section">
//                   <strong>Application Deadline:</strong>
//                   <p>{jdData?.applicationDeadline || 'N/A'}</p>
//                 </div>
//                 <div className="job-section">
//                   <strong>Audio/Video Profile:</strong>
//                   <p>{jdData?.mandatoryProfile ? 'Mandatory' : 'Optional'}</p>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>

//         {/* Additional Actions */}
//         <div className="job-preview-footer">
//           <button className="start-over-btn">Start Over</button>
//           <button className="delete-btn">Delete files</button>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default JobDescriptionPreview;


import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Save, ArrowLeft, CheckCircle2, ChevronLeft, ChevronRight } from 'lucide-react';
import Navbar from '../About/Navbar';
import Footer from '../About/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Container } from '@/components/ui/container';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';

const renderList = (data) => {
  if (Array.isArray(data)) return data;
  if (typeof data === 'string') return data.split(',');
  return [];
};

const JobDescriptionPreview = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();
  const { jdData } = location.state || {};

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 2;

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch('/api/create_jd', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(jdData)
      });
      setShowPopup(true);
      setTimeout(() => {
        navigate('/ch');
      }, 3000);
    } catch (error) {
      console.error('Error generating JD:', error);
    }
  };

  return (
    <div className={cn("min-h-screen w-full bg-background flex flex-col")}>
      <Navbar />
      
      <Container className="py-8">
        <Stack spacing="lg" align="center">
          <Inline className="items-center gap-5">
            <CheckCircle2 className="w-6 h-6 text-green-600" />
            <Heading level="h2" className="text-2xl font-bold text-green-600">Your document is ready</Heading>
          </Inline>

          <Inline className="gap-4">
            <Button
              onClick={handleSubmit}
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
            >
              <Save className="w-4 h-4 mr-2" />
              Save JD
            </Button>
            <Button
              onClick={() => navigate('/jd', { state: { jdData: jdData } })}
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to editing
            </Button>
          </Inline>

          <Card className="w-full max-w-4xl bg-[rgba(65,57,106,1)] border-none">
            <CardHeader className="text-center pb-4">
              <Heading level="h4" className="text-base text-white">JD Title |</Heading>
              <div className="flex justify-center items-center gap-2 mt-2">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className="text-white hover:bg-white/20 h-auto py-2"
                >
                  <ChevronLeft className="w-4 h-4" />
                  {currentPage}
                </Button>
                <Text className="text-white">/</Text>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={nextPage}
                  disabled={currentPage === totalPages}
                  className="text-white hover:bg-white/20 h-auto py-2"
                >
                  {totalPages}
                  <ChevronRight className="w-4 h-4" />
                </Button>
              </div>
            </CardHeader>
            <CardContent className="bg-white rounded-lg p-5 mx-4 mb-4">
              {currentPage === 1 && (
                <Stack spacing="md">
                  <Heading level="h3" className="text-xl font-semibold border-b-2 border-primary pb-2">
                    {jdData?.jobTitle || 'Job Title'}
                  </Heading>
                  <div>
                    <Text className="font-semibold text-base mb-2">Job Summary:</Text>
                    <Text className="text-sm text-foreground">{jdData?.jobSummary || jdData?.job_overview || 'No summary available'}</Text>
                  </div>
                  <div>
                    <Text className="font-semibold text-base mb-2">Responsibilities & Skills:</Text>
                    <ul className="list-none p-0 space-y-2">
                      {renderList(jdData?.keyResponsibilities || jdData?.key_responsibilities).map((resp, index) => (
                        <li key={index} className="bg-muted p-2 rounded text-sm">{resp}</li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <Text className="font-semibold text-base mb-2">Required Skills:</Text>
                    <ul className="list-none p-0 space-y-2">
                      {renderList(jdData?.requiredSkills || jdData?.required_skills).map((skill, index) => (
                        <li key={index} className="bg-muted p-2 rounded text-sm">{skill}</li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <Text className="font-semibold text-base mb-2">Good-to-Have Skills (Optional):</Text>
                    <ul className="list-none p-0 space-y-2">
                      {renderList(jdData?.optionalSkills || jdData?.optional_skills).map((skill, index) => (
                        <li key={index} className="bg-muted p-2 rounded text-sm">{skill}</li>
                      ))}
                    </ul>
                  </div>
                </Stack>
              )}

              {currentPage === 2 && (
                <Stack spacing="md">
                  <div>
                    <Text className="font-semibold text-base mb-2">Work & Culture Details (Optional):</Text>
                    <Text className="text-sm"><strong>Soft Skills:</strong> {renderList(jdData?.softSkills).join(', ') || 'N/A'}</Text>
                    <Text className="text-sm"><strong>Work Hours:</strong> {jdData?.workHours || 'N/A'}</Text>
                    <Text className="text-sm"><strong>Company Culture:</strong> {jdData?.companyCulture || 'N/A'}</Text>
                  </div>
                  <div>
                    <Text className="font-semibold text-base mb-2">Hiring Process:</Text>
                    <Text className="text-sm">{jdData?.hiringProcess || 'N/A'}</Text>
                  </div>
                  <div>
                    <Text className="font-semibold text-base mb-2">Application Deadline:</Text>
                    <Text className="text-sm">{jdData?.applicationDeadline || 'N/A'}</Text>
                  </div>
                  <div>
                    <Text className="font-semibold text-base mb-2">Audio/Video Profile:</Text>
                    <Text className="text-sm">{jdData?.mandatoryProfile ? 'Mandatory' : 'Optional'}</Text>
                  </div>
                </Stack>
              )}
            </CardContent>
          </Card>

          <Inline className="gap-4">
            <Button variant="outline">Start Over</Button>
            <Button variant="destructive">Delete files</Button>
          </Inline>
        </Stack>
      </Container>

      <Dialog open={showPopup} onOpenChange={setShowPopup}>
        <DialogContent className="text-center">
          <DialogHeader>
            <div className="flex justify-center mb-4">
              <CheckCircle2 className="w-12 h-12 text-green-600" />
            </div>
            <DialogTitle className="text-2xl font-bold">Successfully Created JD!</DialogTitle>
            <DialogDescription className="mt-2">
              Your job description has been saved successfully.
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>

      <Footer />
    </div>
  );
};

export default JobDescriptionPreview;
